import { useEffect, useMemo, useRef, useState } from 'react';
import { permissionStore } from '@web3fe/infra';
import { HomeDataDTO, HomeDataParams } from '@/types/home';
import { getHomeData } from '@/services/home';

export enum ActiveStatus {
  UN_COMING = 'unComing',
  ON_GOING = 'onGoing',
  ENDED = 'ended',
}

export const useHomeData = () => {
  const [homeData, setHomeData] = useState<HomeDataDTO | null>(null);
  // 防抖计时器
  const timerRef = useRef(null);
  // 记录最后一次请求
  const lastReqRef = useRef(null);
  // 防抖延迟
  const DELAY = 500;

  // const demoReq = async (params) => {
  //   let timeout = Math.random() * 2000 + 2000;
  //   if (params.walletId) {
  //     timeout = Math.random() * 2000;
  //   }
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve({
  //         result: params,
  //       });
  //     }, timeout);
  //   });
  // };

  const init = async (params: HomeDataParams = {}) => {
    // 清除之前的计时器
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // 设置一个新的计时器
    timerRef.current = setTimeout(async () => {
      // 创建一个新的 Promise
      const newPromise = getHomeData(params);
      // 更新 最后一次请求
      lastReqRef.current = { promise: newPromise, resolve: null, reject: null };
      try {
        // 等待 Promise 完成
        const result = await newPromise;
        // 处理结果
        if (result.success) {
          setHomeData(result.result);
        }
      } catch (error) {
        // 处理错误
        console.error('Error fetching data:', error);
      }
    }, DELAY);
  };

  useEffect(() => {
    // 清除防抖计时器
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const activeStatus = useMemo(() => {
    if (homeData?.startTime && homeData?.endTime) {
      const now = new Date().getTime();
      if (now < homeData.startTime) {
        return ActiveStatus.UN_COMING;
      } else if (now > homeData.endTime) {
        return ActiveStatus.ENDED;
      } else {
        return ActiveStatus.ON_GOING;
      }
    } else {
      return ActiveStatus.UN_COMING;
    }
  }, [homeData]);

  const isUpcoming = useMemo(() => {
    return activeStatus === ActiveStatus.UN_COMING;
  }, [activeStatus]);

  const isActive = useMemo(() => {
    return activeStatus === ActiveStatus.ON_GOING;
  }, [activeStatus]);

  const isEnd = useMemo(() => {
    return activeStatus === ActiveStatus.ENDED;
  }, [activeStatus]);

  const showEarn = useMemo(() => {
    return ['KZ', 'TR'].includes(permissionStore.state.countryCode);
  }, [permissionStore.state.countryCode]);

  return {
    homeData,
    init,
    activeStatus,
    isUpcoming,
    isActive,
    isEnd,
    showEarn,
  };
};
